// @ts-nocheck
import { cardListStyles } from "@insite/content-library/Components/CardList";

Object.assign(cardListStyles, {
    gridContainer: {
        gap: 0,
    },
});
